module.exports = __webpack_public_path__ + "static/media/multi-drm-icon.8e5ae8e4.svg";